/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelAllLoadboardServices.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/all-loadboard-services";

export class AutogenModelAllLoadboardServices<RowType extends ModelRow> extends Endpoint<RowType, RowAllLoadboardServicesFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowAllLoadboardServices extends ModelRow<RowAllLoadboardServicesFields> {
	constructor(values?: Partial<RowAllLoadboardServicesFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowAllLoadboardServicesFields {
	"load_board_service.access_token": string;
	"load_board_service.account_id": string;
	"load_board_service.address": string;
	"load_board_service.available_tractors": string;
	"load_board_service.carrier_lane_updates": string;
	"load_board_service.carrier_updates": string;
	"load_board_service.client_id": string;
	"load_board_service.client_secret": string;
	"load_board_service.company_id": string;
	"load_board_service.email_post_failure": string;
	"load_board_service.extract_capacity": string;
	"load_board_service.ftp_connect_mode": string;
	"load_board_service.header_data": string;
	"load_board_service.id": string;
	"load_board_service.integration_link": string;
	"load_board_service.is_active": string;
	"load_board_service.last_posting_date": Date;
	"load_board_service.last_refresh_date": Date;
	"load_board_service.local_file": string;
	"load_board_service.main_account_user_id": string;
	"load_board_service.method": string;
	"load_board_service.passwd": string;
	"load_board_service.pnn_post_role": string;
	"load_board_service.pnn_schedule_id": string;
	"load_board_service.port": number;
	"load_board_service.posting_format": string;
	"load_board_service.posting_frequency": number;
	"load_board_service.proxy": string;
	"load_board_service.refresh_daily": string;
	"load_board_service.refresh_schedule_code": string;
	"load_board_service.refresh_token": string;
	"load_board_service.remote_dir": string;
	"load_board_service.remote_file": string;
	"load_board_service.report_carrier": string;
	"load_board_service.send_auto_update": string;
	"load_board_service.service_name": string;
	"load_board_service.service_type": string;
	"load_board_service.ssh_key_file": string;
	"load_board_service.ssh_key_pwd": string;
	"load_board_service.token_expires": Date;
	"load_board_service.truckstop_user_email": string;
	"load_board_service.userid": string;
	"pbw_loadboard_services.access_token": string;
	"pbw_loadboard_services.account_id": string;
	"pbw_loadboard_services.client_id": string;
	"pbw_loadboard_services.client_secret": string;
	"pbw_loadboard_services.company_id": string;
	"pbw_loadboard_services.dat_primary_contact_method": string;
	"pbw_loadboard_services.dat_rest_auth_url": string;
	"pbw_loadboard_services.dat_rest_enabled": string;
	"pbw_loadboard_services.dat_second_contact_method": string;
	"pbw_loadboard_services.days_after_pickup": number;
	"pbw_loadboard_services.days_before_pickup": number;
	"pbw_loadboard_services.description": string;
	"pbw_loadboard_services.excluded_brokerage_status": string;
	"pbw_loadboard_services.excluded_commodity_id": string;
	"pbw_loadboard_services.excluded_customer_id": string;
	"pbw_loadboard_services.excluded_order_mode": string;
	"pbw_loadboard_services.excluded_order_type_id": string;
	"pbw_loadboard_services.excluded_revenue_code_id": string;
	"pbw_loadboard_services.id": string;
	"pbw_loadboard_services.is_active": string;
	"pbw_loadboard_services.last_cancel_check": Date;
	"pbw_loadboard_services.last_posting_update": Date;
	"pbw_loadboard_services.last_repost_date": Date;
	"pbw_loadboard_services.password": string;
	"pbw_loadboard_services.posting_end": Date;
	"pbw_loadboard_services.posting_frequency": number;
	"pbw_loadboard_services.posting_start": Date;
	"pbw_loadboard_services.refresh_token": string;
	"pbw_loadboard_services.remote_directory": string;
	"pbw_loadboard_services.remote_port": number;
	"pbw_loadboard_services.repost_enabled": string;
	"pbw_loadboard_services.repost_frequency": number;
	"pbw_loadboard_services.service_type": string;
	"pbw_loadboard_services.sftp_file_prefix": string;
	"pbw_loadboard_services.token_expires": Date;
	"pbw_loadboard_services.truck_search_status_enabled": string;
	"pbw_loadboard_services.url": string;
	"pbw_loadboard_services.user_id": string;
	"pbw_loadboard_services.vendor_user_id": string;
	"pbw_loadboard_services.weekend_posting": string;
}

